export const ICON = Object.freeze({
  bold: `
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path fill-rule="evenodd" clip-rule="evenodd" d="M15.7328 11.76C16.8557 10.9943 17.6429 9.73714 17.6429 8.57143C17.6429 5.98857 15.6171 4 13.0124 4H6.93496C6.29827 4 5.77734 4.51429 5.77734 5.14286V18.8571C5.77734 19.4857 6.29827 20 6.93496 20H13.626C16.0222 20 18.2101 18.0686 18.2217 15.6914C18.2333 13.9429 17.2377 12.4457 15.7328 11.76ZM9.25019 6.85715H12.723C13.6838 6.85715 14.4595 7.62286 14.4595 8.57144C14.4595 9.52001 13.6838 10.2857 12.723 10.2857H9.25019V6.85715ZM13.3018 17.1429H9.25019V13.7143H13.3018C14.2627 13.7143 15.0383 14.48 15.0383 15.4286C15.0383 16.3772 14.2627 17.1429 13.3018 17.1429Z" fill="currentColor" />
    </svg>
  `,
  italic: `
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path fill-rule="evenodd" clip-rule="evenodd" d="M9.66667 5.71429C9.66667 6.66286 10.4483 7.42857 11.4167 7.42857H12.245L8.255 16.5714H6.75C5.78167 16.5714 5 17.3371 5 18.2857C5 19.2343 5.78167 20 6.75 20H12.5833C13.5517 20 14.3333 19.2343 14.3333 18.2857C14.3333 17.3371 13.5517 16.5714 12.5833 16.5714H11.755L15.745 7.42857H17.25C18.2183 7.42857 19 6.66286 19 5.71429C19 4.76571 18.2183 4 17.25 4H11.4167C10.4483 4 9.66667 4.76571 9.66667 5.71429Z" fill="currentColor" />
    </svg>
  `,
  strike: `
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path fill-rule="evenodd" clip-rule="evenodd" d="M11.9984 20C13.1718 20 14.1318 19.04 14.1318 17.8667V16.8H9.8651V17.8667C9.8651 19.04 10.8251 20 11.9984 20ZM4.53177 5.6C4.53177 6.48533 5.24644 7.2 6.13177 7.2H9.8651V10.4H14.1318V7.2H17.8651C18.7504 7.2 19.4651 6.48533 19.4651 5.6C19.4651 4.71467 18.7504 4 17.8651 4H6.13177C5.24644 4 4.53177 4.71467 4.53177 5.6ZM3.4651 14.6667H20.5318C21.1184 14.6667 21.5984 14.1867 21.5984 13.6C21.5984 13.0133 21.1184 12.5333 20.5318 12.5333H3.4651C2.87844 12.5333 2.39844 13.0133 2.39844 13.6C2.39844 14.1867 2.87844 14.6667 3.4651 14.6667Z" fill="currentColor" />
    </svg>
  `,
  list: `
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path fill-rule="evenodd" clip-rule="evenodd" d="M4 5C3.44772 5 3 5.44772 3 6C3 6.55228 3.44772 7 4 7C4.55228 7 5 6.55228 5 6C5 5.44772 4.55228 5 4 5ZM4 11C3.44772 11 3 11.4477 3 12C3 12.5523 3.44772 13 4 13C4.55228 13 5 12.5523 5 12C5 11.4477 4.55228 11 4 11ZM3 18C3 17.4477 3.44772 17 4 17C4.55228 17 5 17.4477 5 18C5 18.5523 4.55228 19 4 19C3.44772 19 3 18.5523 3 18ZM8 5C7.44772 5 7 5.44772 7 6C7 6.55228 7.44772 7 8 7H20C20.5523 7 21 6.55228 21 6C21 5.44772 20.5523 5 20 5H8ZM8 11C7.44772 11 7 11.4477 7 12C7 12.5523 7.44772 13 8 13H20C20.5523 13 21 12.5523 21 12C21 11.4477 20.5523 11 20 11H8ZM7 18C7 17.4477 7.44772 17 8 17H20C20.5523 17 21 17.4477 21 18C21 18.5523 20.5523 19 20 19H8C7.44772 19 7 18.5523 7 18Z" fill="currentColor" />
    </svg>
  `,
  image: `
    <svg width="24" height="24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M19.999 4h-16c-1.103 0-2 .897-2 2v12c0 1.103.897 2 2 2h16c1.103 0 2-.897 2-2V6c0-1.103-.897-2-2-2zm-13.5 3a1.5 1.5 0 110 3 1.5 1.5 0 010-3zm5.5 10h-7l4-5 1.5 2 3-4 5.5 7h-7z" fill="currentColor"/>
    </svg>
  `,
});

export const toolbarPositions = Object.freeze({
  TOP: 'top',
  BOTTOM: 'bottom',
});

export const toolbarOptions = Object.freeze({
  BOLD: 'bold',
  ITALIC: 'italic',
  STRIKE: 'strike',
  LIST: 'list',
  IMAGE: 'image',
});

const MENTIONS_PREFIX = 'brvd-mentions';
const createMentionsClass = (className: string) => `${MENTIONS_PREFIX}__${className}`;

export const MENTION_CONTAINER_ID = 'ql-mention-list-container';

export const MENTIONS_EMPTY_AVATAR_URL = 'https://bravado.co/images/original/missing.png';
export const MENTIONS_CONTAINER_CLASS = createMentionsClass('container');
export const MENTIONS_ITEM_CLASS = createMentionsClass('item');
export const MENTIONS_EMPTY_AVATAR_PLACEHOLDER_CLASS = createMentionsClass('item-image-placeholder');
export const MENTIONS_AVATAR_CLASS = createMentionsClass('item-image');
export const MENTIONS_AVATAR_SIZE = 32;
